import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
})
export class LoaderComponent implements OnChanges {
  progress = 0;
  isVisible = true;

  @Input('loaderIcon') loaderIcon = '';
  @Input('loaderLabel') loaderLabel = '';
  @Input('response') response: 'SUCCESS' | 'ERROR' | null = null;
  // @Input('response') response: 'SUCCESS' | 'ERROR' | null = 'ERROR';

  progressInterval: any;

  ngOnInit() {
    this.startProgress();
  }

  // Detect changes to input properties
  ngOnChanges(changes: SimpleChanges) {
    // If response input changes and holds 'success' or 'error', complete the progress
    if (changes['response'] && (this.response === 'SUCCESS' || this.response === 'ERROR')) {
      this.completeProgress();
    }
  }

  startProgress() {
    const interval = 100; // Smaller update interval in milliseconds for smoother progress
    const duration = 100000; // Total duration for the progress to complete (100 seconds)

    const steps = duration / interval; // Total number of updates over the full duration
    const increment = 100 / steps; // How much progress to add at each step

    this.progressInterval = setInterval(() => {
      this.progress = Math.min(100, this.progress + increment); // Ensure progress does not exceed 100%

      // Uncomment this if you want the loader to stop when progress reaches 100%.
      if (this.progress >= 100) {
        this.completeProgress();
      }
    }, interval);
  }

  completeProgress() {
    clearInterval(this.progressInterval);
    if (this.response === 'SUCCESS') {
      this.progress = 100;
      setTimeout(() => {
        this.isVisible = false;
      }, 2000);
    } else {
      setTimeout(() => {
        this.isVisible = false;
      }, 5000);
    }
  }
}
